import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { Typography } from '@mui/material';

import { CharacterCounterProps } from './models/character-counter-props.model';

const CharacterCounter: FunctionComponent<CharacterCounterProps> = (
  props: PropsWithChildren<CharacterCounterProps>
): JSX.Element => {
  return (
    <Typography
      className={props.className}
      sx={{
        color: theme => theme.palette.appGrey.darkGray,
        fontSize: '12px',
      }}
      data-testid="character-counter-component"
    >
      {props.current === props.max
        ? 'Maximum characters are reached'
        : `${props.current} / ${props.max} characters`}
    </Typography>
  );
};

export default CharacterCounter;
